export const gfBilling = {
    tariffs: {
        [2]: {period: "месяц", price: 9.99},
        [3]: {period: "1 год", price: 99.99}
    }
}